import { render, staticRenderFns } from "./OldShopOA.vue?vue&type=template&id=5d53406b&scoped=true&"
import script from "./OldShopOA.vue?vue&type=script&lang=js&"
export * from "./OldShopOA.vue?vue&type=script&lang=js&"
import style0 from "./OldShopOA.vue?vue&type=style&index=0&id=5d53406b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d53406b",
  null
  
)

export default component.exports